import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowRight, Clock, Target } from 'lucide-react';

export function QuestionnairePrompt({ variant = 'banner' }) {
  const navigate = useNavigate();

  if (variant === 'hero') {
    return (
      <section className="relative overflow-hidden bg-gradient-to-r from-teal-600 to-emerald-600 rounded-2xl p-6 sm:p-8" data-testid="questionnaire-hero-cta">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-4 right-8 w-32 h-32 rounded-full bg-white blur-3xl" />
          <div className="absolute bottom-4 left-12 w-24 h-24 rounded-full bg-yellow-200 blur-2xl" />
        </div>
        <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <div className="w-12 h-12 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center shrink-0">
            <Target className="h-6 w-6 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-white mb-1">Get your personalised matches</h3>
            <p className="text-sm text-white/80 max-w-lg">
              Take a 2-minute quiz and we'll match you with side hustles that fit your skills, schedule, and goals. No fluff — just real opportunities.
            </p>
          </div>
          <button
            onClick={() => navigate('/match')}
            className="inline-flex items-center gap-2 px-6 py-3 bg-white hover:bg-slate-50 text-teal-700 font-semibold rounded-xl transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            data-testid="questionnaire-cta-button"
          >
            <Sparkles className="h-4 w-4" />
            Take the quiz
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
        <div className="relative flex items-center gap-4 mt-4 text-xs text-white/70">
          <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> 2 minutes</span>
          <span className="flex items-center gap-1"><Target className="h-3 w-3" /> 22 questions</span>
          <span className="flex items-center gap-1"><Sparkles className="h-3 w-3" /> AI-powered matching</span>
        </div>
      </section>
    );
  }

  // Default: compact dashboard banner
  return (
    <div className="bg-gradient-to-r from-teal-50 to-emerald-50 border border-teal-200/60 rounded-xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-testid="questionnaire-prompt-banner">
      <div className="w-10 h-10 rounded-lg bg-teal-100 flex items-center justify-center shrink-0">
        <Sparkles className="h-5 w-5 text-teal-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-slate-800">Complete your profile for better matches</p>
        <p className="text-xs text-slate-500 mt-0.5">Answer a few questions and get AI-powered recommendations tailored to you.</p>
      </div>
      <button
        onClick={() => navigate('/match')}
        className="inline-flex items-center gap-1.5 px-4 py-2 bg-teal-500 hover:bg-teal-600 text-white text-sm font-medium rounded-lg transition-colors shrink-0"
        data-testid="questionnaire-prompt-button"
      >
        Start quiz <ArrowRight className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
